module.exports = __webpack_public_path__ + "img/locker-back-icon-disabled.b0d29080.svg";